import { useCallback, useEffect, useState } from 'react'
import { updateRatingContainerVisibility } from '../utils/updateBazaarvoiceStyles'

export function useDisplayingBVComponents(showEmptyReviews) {
  const [bvReviewsCountDiv, setBvReviewsCountDiv] = useState(null)

  // observe if numReviews div was injected by BV scripts
  const observeBazarvoiceReviewsAppearance = useCallback(() => {
    const numReviews = document.getElementsByClassName('bv_numReviews_text')[0]
    if (!numReviews) return

    setBvReviewsCountDiv(numReviews)
  }, [setBvReviewsCountDiv])

  const updateRatingContainerVisibilityStyles = useCallback(() => {
    if (!bvReviewsCountDiv) return
    updateRatingContainerVisibility({ bvReviewsCountDiv, showEmptyReviews })
  }, [bvReviewsCountDiv, showEmptyReviews])

  useEffect(() => {
    const observer = new MutationObserver(observeBazarvoiceReviewsAppearance)
    observer.observe(document.querySelector('.mxd-rating'), {
      childList: true,
      subtree: true
    })

    if (bvReviewsCountDiv) {
      updateRatingContainerVisibilityStyles()
      observer.disconnect()
    }
  }, [bvReviewsCountDiv, observeBazarvoiceReviewsAppearance, updateRatingContainerVisibilityStyles])
}
